import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SubmissionDocs } from "../../data-model/submissionDocs";
import { DataState } from "../store/store";

const initialState: DataState<SubmissionDocs> = {
  loading: false,
  error: null,
  data: null,
};

const submissionDocsSlice = createSlice({
  name: "submissionDocsSlice",
  initialState,
  reducers: {
    fetchingSubmissionDocs(state) {
      state.loading = true;
      state.error = null;
    },
    fetchingSubmissionDocsSuccess(state, action: PayloadAction<any[]>) {
      state.data = mapAllDocumentsToSubmissionDocs(
        action.payload,
      ) as SubmissionDocs;
      state.loading = false;
      state.error = null;
    },
    fetchingSubmissionDocsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetSubmissionDocs(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
});

const mapAllDocumentsToSubmissionDocs = (docs: any[]) => {
  return docs.reduce((acc, doc) => {
    const docId = doc.id;
    acc[docId] = doc;
    return acc;
  }, {} as SubmissionDocs);
};

export const resetSubmissionDocs = () => {
  return submissionDocsSlice.actions.resetSubmissionDocs();
};

export default submissionDocsSlice.reducer;
